import React from 'react';
import { Button } from '@cokitchen/cokitchen-components';
import { Link } from 'react-router-dom';
import AccountCompleteImg from 'assets/images/account-complete.gif';
import { ROUTE_KEYS } from 'utils/constants';
import useDashboardContext from 'contexts/dashboard.context';
import { ENUM_ONBOARDING_STATUS } from 'utils/enum';

const AccountComplete = () => {
  const { onboarding, setOnboarding } = useDashboardContext();

  return (
    <div className='border border-gray-14 w-full py-2 rounded-md p-6'>
      <div className='flex flex-col justify-center items-center text-center w-full h-full space-y-3 py-10'>
        <img
          src={AccountCompleteImg}
          alt={'Account Complete Image'}
          className='w-[60px] h-[60px] md:w-[90px] md:h-[90px] object-contain p-[5px] rounded-full bg-[#0080E5]'
        />

        <h1 className='text-gray-10 text-base font-medium sm:text-lg md:text-2xl pt-3'>
          Account setup complete
        </h1>
        <p className='text-sm sm:text-base text-gray-9'>
          Congratulations on setting up your FoodCourt Business account.{' '}
        </p>
        <Link to={`${ROUTE_KEYS.APP}/${ROUTE_KEYS.DASHBOARD}`} className='pt-8'>
          <Button
            small
            className='h-[35px] md:h-[40px] text-sm'
            variant='block'
            color='primary'
            onClick={() =>
              setOnboarding(
                onboarding.map((step) => ({ ...step, status: ENUM_ONBOARDING_STATUS.COMPLETED }))
              )
            }>
            Go to dashboard
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default AccountComplete;
